{
  "endTime": "Terminar tempo",
  "startTime": "Iniciar tempo",
  "time": "Tempo"
}
